module.exports = __webpack_public_path__ + "static/img/naturalCircle7h.af7f0bf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/naturalCircle7h.svg
// module id = r8YB
// module chunks = 1